import React from 'react';

import AddTeammateLogoUrl from './add-teammate-logo.png';

function AddTeammateLogo({ ...props }) {
  return <img src={AddTeammateLogoUrl} alt="add-teammate-logo.png" {...props} />;
}

export default AddTeammateLogo;
